// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1___308ee710a1ee9a23ef8","cls2":"Comments-cls2__d39800d1dd1cadfe2a54 Comments-cls1___308ee710a1ee9a23ef8"};